import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';
import { clsx } from 'clsx';

type Props = {
  className?: string;
  gutter?: boolean | number;
  fullWidth?: boolean;
};

export const Divider = ({
  className,
  gutter = false,
  fullWidth = true,
}: Props) => (
  <>
    <hr
      className={clsx({
        'wk-divider': true,
        [className || '']: true,
        'wk-divider--gutter': typeof gutter === 'boolean' ? gutter : true,
      })}
    />
    <style jsx>{`
      .wk-divider {
        ${fullWidth ? 'width: 100%' : ''};
        border-top: none;
        border-bottom: solid 1px ${Colors.steel};
        margin: 0;
      }

      .wk-divider--gutter {
        margin: ${typeof gutter === 'boolean' ? 24 : gutter}px 0;
      }
    `}</style>
  </>
);
